import { Module } from 'vuex';
import { RootState } from '@/store/index';
import { getProvision, putProvision } from '@/api/provisionEndpoint';

type ProvisionState = {
  consentFlg1?: boolean;
  consentFlg2?: boolean;
  consentFlg3?: boolean;
  consentFlg4?: boolean;
  lastChargeFlg?: boolean;
  aboutDateInterview?: string;
  aboutCommunicationMedia?: string;
  wishJobChangeDateId?: string;
  wishJobChangeDateDisplayFlg?: boolean;
  changeDateConvert?: ChangeDateConvert[];

};

type ChangeDateConvert = {
  value: string;
  label: string;
};

const provisionModule: Module<ProvisionState, RootState> = {
  namespaced: true,
  state: {
    consentFlg1: undefined,
    consentFlg2: undefined,
    consentFlg3: undefined,
    consentFlg4: undefined,
    lastChargeFlg: undefined,
    aboutDateInterview: undefined,
    aboutCommunicationMedia: undefined,
    wishJobChangeDateId: undefined,
    wishJobChangeDateDisplayFlg: undefined,
    changeDateConvert: [],
  },
  getters: {
    provision(state) {
      return state;
    },
    changeDateConvert(state) {
      return state.changeDateConvert;
    },
  },

  mutations: {
    set(state, value: ProvisionState) {
      Object.assign(state, value);
    },
  },

  actions: {
    async receive({ commit }) {
      const provision = await getProvision();
      commit('set', provision);
    },
    async receiveOnlyOptional({ commit }) {
      const provision = await getProvision();
      commit('set', {
        consentFlg1: undefined,
        consentFlg2: undefined,
        consentFlg3: undefined,
        consentFlg4: undefined,
        lastChargeFlg: undefined,
        aboutDateInterview: provision.aboutDateInterview ? provision.aboutDateInterview : '',
        aboutCommunicationMedia: provision.aboutCommunicationMedia ? provision.aboutCommunicationMedia : '',
        wishJobChangeDateId: provision.wishJobChangeDateId ? provision.wishJobChangeDateId : '',
        wishJobChangeDateDisplayFlg: provision.wishJobChangeDateDisplayFlg ? provision.wishJobChangeDateDisplayFlg : '',
      });
    },
    async send({ state }) {
      const {
        consentFlg1,
        consentFlg2,
        consentFlg3,
        consentFlg4,
        lastChargeFlg,
        aboutDateInterview,
        aboutCommunicationMedia,
        wishJobChangeDateId,
        wishJobChangeDateDisplayFlg,
      } = state;

      await putProvision({
        consentFlg1,
        consentFlg2,
        consentFlg3,
        consentFlg4,
        lastChargeFlg,
        aboutDateInterview,
        aboutCommunicationMedia,
        wishJobChangeDateId,
        wishJobChangeDateDisplayFlg,
      });
    },
  },
};

export default provisionModule;
